

















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { RequestMessage } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import { onlyNumber } from '@/utils/common'
import { LoteNotificacao, LoteNotificacaoProgresso, LotesNotificacaoParams } from '@/types/interfaces/LoteNotificacao'
import useLoteNotificacaoPolling, { loteFinalizado, percentualProcessado } from '@/composables/useLoteNotificacaoPolling/useLoteNotificacaoPolling'

import ModalNotificacaoEmailProcessamento from '@/components/RemuneracaoMedica/financeiro/modais/ModalNotificacaoEmailProcessamento.vue'
import ModalNotificacaoEmailDetalhes from '@/components/RemuneracaoMedica/financeiro/modais/ModalNotificacaoEmailDetalhes.vue'
import ModalNotificacaoEmailPreview from '@/components/RemuneracaoMedica/financeiro/modais/ModalNotificacaoEmailPreview.vue'

@Component({
  components: {
    ModalNotificacaoEmailProcessamento,
    ModalNotificacaoEmailDetalhes,
    ModalNotificacaoEmailPreview,
  },
})
export default class ViewFinanceiroNotificarEmail extends Vue {
  $refs!: {
    diaForm: any,
  }

  inputFiles: any[] = []
  loadNotificar: boolean = false
  loadTemplate: boolean = false
  dia: any = ''
  envioEmail: any = ''
  grupoRepasse: any = ''
  showModalTemplateConfig: boolean = false

  polling!: ReturnType<typeof useLoteNotificacaoPolling>
  loteAcompanhadoId: string | null = null
  loteAcompanhado: LoteNotificacaoProgresso | null = null
  loteExibidoId: string | null = null
  loteExibido: LoteNotificacaoProgresso | null = null
  showProcessingModal: boolean = false

  loadingHistorico: boolean = false
  consultaHistorico: number = 0
  lotesHistorico: LoteNotificacao[] = []
  lotesTotalCount: number = 0
  filtroStatus: string = ''
  lotesPagination: any = { page: 1, rowsPerPage: 5, totalItems: 0 }
  paginacaoCarregada: string = ''
  lotesHeaders: any[] = [
    { text: 'Data do envio', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Total', value: 'totalItens', align: 'center', sortable: false },
    { text: 'Enviados', value: 'processados', align: 'center', sortable: false },
    { text: 'Erros', value: 'erros', align: 'center', sortable: false },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
    { text: 'Ação', value: 'action', align: 'center', sortable: false },
  ]

  showDetalhesModal: boolean = false
  detalhesLote: LoteNotificacao | null = null

  get isPolling() { return !!this.loteAcompanhadoId }

  get loteProgresso() { return percentualProcessado(this.loteAcompanhado) }

  // O modal pode mostrar um lote do histórico enquanto outro segue acompanhado em segundo plano.
  get loteNoModal() {
    return this.loteExibidoId && this.loteExibidoId === this.loteAcompanhadoId ? this.loteAcompanhado : this.loteExibido
  }

  get loteNoModalProgresso() { return percentualProcessado(this.loteNoModal) }

  diaRules: any = {
    valid: true,
    dia: [
      v => !!v || 'O campo dia é obrigatório.',
    ],
  }

  get getDia() { return this.dia }
  set getDia(value: any) { this.dia = value }

  get getEnvioEmail() { return this.envioEmail }
  set getEnvioEmail(value: any) { this.envioEmail = value }

  get getGrupoRepasse() { return this.grupoRepasse }
  set getGrupoRepasse(value: any) { this.grupoRepasse = value }

  get loadingNotificar() { return this.loadNotificar }
  set loadingNotificar(value: boolean) { this.loadNotificar = value }

  get loadingTemplate() { return this.loadTemplate }
  set loadingTemplate(value: boolean) { this.loadTemplate = value }

  get getRequestMessage() { return new RequestMessage() }

  get getFinanceiroStore() { return getModule(FinanceiroStore, this.$store) }
  get getGrupoRepasseItensAll() { return this.getFinanceiroStore.grupoRepasseItensAll }
  set getGrupoRepasseItensAll(value: any[]) { this.getFinanceiroStore.grupoRepasseItensAll = value }

  onlyNumberUtil(value) { return onlyNumber(value) }

  loteStatusMap: Record<string, { color: string, icon: string, label: string }> = {
    Concluido: { color: 'success', icon: 'mdi-check-circle', label: 'Concluído' },
    EmProcessamento: { color: 'primary', icon: 'mdi-progress-clock', label: 'Processando' },
    Erro: { color: 'error', icon: 'mdi-alert-circle', label: 'Erro' },
    ConcluidoComErros: { color: 'warning', icon: 'mdi-alert-circle-outline', label: 'Concluído com Erros' },
  }

  getStatusColor(status: string) { return this.loteStatusMap[status]?.color || 'grey' }
  getStatusIcon(status: string) { return this.loteStatusMap[status]?.icon || 'mdi-help-circle' }
  getStatusLabel(status: string) { return this.loteStatusMap[status]?.label || status }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return '-'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  async sendEmailCobrancaNotaFiscal() {
    this.loadingNotificar = true
    const params: any = {
      diasDesdeUltimaNotificacao: this.getDia ? this.getDia : 0,
      grupoRepasseId: this.grupoRepasse ? this.grupoRepasse : null,
      // eslint-disable-next-line
      envioEmailTipo: parseInt(this.envioEmail),
    }

    const response = await this.getFinanceiroStore.sendEmailCobrancaNotaFiscal(params)
    if (response.success && response.data) {
      this.getDia = ''
      this.envioEmail = '0'
      this.grupoRepasse = ''
      const loteId = response.data
      this.loteAcompanhado = { id: loteId, totalItens: 0, processados: 0, erros: 0, status: 'EmProcessamento' }
      this.iniciarAcompanhamento(loteId)
      this.loteExibidoId = loteId
      this.showProcessingModal = true
      EventBus.$emit('setSnackbar', { show: true, text: 'Os e-mails de cobrança estão sendo enviados. Você pode acompanhar o progresso em tempo real.', icon: 'info', color: '#1976D2' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível enviar. Tente novamente.', icon: 'warning', color: '#C62828' })
    }

    this.loadingNotificar = false
    this.loadLotesHistorico()
  }

  iniciarAcompanhamento(loteId: string) {
    this.loteAcompanhadoId = loteId
    this.polling.iniciar(loteId)
  }

  encerrarAcompanhamento() {
    if (this.loteExibidoId === this.loteAcompanhadoId) this.loteExibido = this.loteAcompanhado
    this.loteAcompanhadoId = null
  }

  avisarFimDoLote(lote: LoteNotificacaoProgresso) {
    if (lote.status === 'ConcluidoComErros') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Envio concluído, porém com alguns erros.', icon: 'warning', color: '#F57C00' })
    } else if (lote.status === 'Erro') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro no processamento do lote.', icon: 'warning', color: '#C62828' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'O processamento do envio foi concluído!', icon: 'done', color: '#2E7D32' })
    }
  }

  abrirLoteAcompanhado() {
    this.loteExibidoId = this.loteAcompanhadoId
    this.showProcessingModal = true
  }

  async checkStatusAndShowModal(loteId: string) {
    if (loteId === this.loteAcompanhadoId) {
      this.abrirLoteAcompanhado()
      return
    }

    const response = await this.getFinanceiroStore.getLoteNotificacao(loteId)
    if (!response.success || !response.data) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível consultar o andamento do lote.', icon: 'warning', color: '#C62828' })
      return
    }

    const lote: LoteNotificacaoProgresso = response.data
    this.loteExibido = lote
    this.loteExibidoId = loteId
    this.showProcessingModal = true

    if (!loteFinalizado(lote.status) && !this.loteAcompanhadoId) {
      this.loteAcompanhado = lote
      this.iniciarAcompanhamento(loteId)
    }
  }

  closeProcessingModal() {
    this.showProcessingModal = false
    this.loadLotesHistorico()
  }

  async loadLotesHistorico() {
    this.paginacaoCarregada = `${this.lotesPagination.page}|${this.lotesPagination.rowsPerPage}`
    this.loadingHistorico = true
    const params: LotesNotificacaoParams = {
      page: this.lotesPagination.page,
      pageSize: this.lotesPagination.rowsPerPage,
    }
    if (this.filtroStatus) params.status = this.filtroStatus

    this.consultaHistorico += 1
    const consulta = this.consultaHistorico
    const response = await this.getFinanceiroStore.getLotesNotificacao(params)
    if (consulta !== this.consultaHistorico) return

    if (response.success && response.data) {
      this.lotesHistorico = response.data.items || []
      this.lotesTotalCount = response.data.totalCount || 0
    } else {
      this.lotesHistorico = []
      this.lotesTotalCount = 0
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível carregar o histórico de envios.', icon: 'warning', color: '#C62828' })
    }
    this.lotesPagination.totalItems = this.lotesTotalCount
    this.loadingHistorico = false
  }

  @Watch('filtroStatus')
  onFiltroStatusChanged() {
    this.lotesPagination.page = 1
    this.loadLotesHistorico()
  }

  @Watch('lotesPagination', { deep: true })
  onLotesPaginationChanged() {
    const paginacaoAtual = `${this.lotesPagination.page}|${this.lotesPagination.rowsPerPage}`

    if (paginacaoAtual === this.paginacaoCarregada) {
      return
    }

    this.loadLotesHistorico()
  }

  openDetalhes(lote: LoteNotificacao) {
    this.detalhesLote = lote
    this.showDetalhesModal = true
  }

  created() {
    this.polling = useLoteNotificacaoPolling({
      buscarLote: loteId => this.getFinanceiroStore.getLoteNotificacao(loteId),
      aoAtualizar: (lote) => { this.loteAcompanhado = lote },
      aoFinalizar: (lote) => {
        this.encerrarAcompanhamento()
        this.avisarFimDoLote(lote)
        this.loadLotesHistorico()
      },
      aoExpirar: () => {
        this.encerrarAcompanhamento()
        EventBus.$emit('setSnackbar', { show: true, text: 'O acompanhamento em tempo real foi encerrado. Consulte o histórico de envios para ver o andamento.', icon: 'warning', color: '#F57C00' })
        this.loadLotesHistorico()
      },
    })
  }

  beforeDestroy() {
    this.polling.parar()
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getGrupoRepasseAll()
    this.envioEmail = '0'
    await this.loadLotesHistorico()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }
}
